import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  id: "inset-iframe-window",
  src: '/oa/team/create-team',
  width: "375px",
  height: "650px",
  frameborder: "0"
}, null, -1)

import { defineEmits } from '@vue/runtime-core'
import { useDialogPluginComponent } from 'quasar'

export default /*#__PURE__*/_defineComponent({
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {


const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent()

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    persistent: "",
    class: "q-dialog__backdrop_dark"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onDialogCancel) && _unref(onDialogCancel)(...args))),
            class: "iconfont absolute p-2 top-4 right-4 font-normal text-dark text-sm pt-1 pr-2 cursor-pointer"
          }, "  "),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})